let loaded = false;

function _load(options = {}) {
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.media = 'all';

    R.forEach(([key, value]) => (link[key] = value), Object.entries(options));

    head.appendChild(link);

    return head;
}

export function loadIconCss() {
    if (loaded) {
        return;
    }

    loaded = true;

    _load({
        href: '//cdn.materialdesignicons.com/2.0.46/css/materialdesignicons.min.css',
    });

    _load({
        href: 'https://pro.fontawesome.com/releases/v5.7.2/css/all.css',
        integrity:
            'sha384-6jHF7Z3XI3fF4XZixAuSu0gGKrXwoX/w3uFPxC56OtjChio7wtTGJWRW53Nhx6Ev',
        crossOrigin: 'anonymous',
    });

    _load({
        href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
    });
}
